// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordUpdateModal_wrapper__vhZdC","heading":"PasswordUpdateModal_heading__HxpFN"};